// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"163":"59a8b111","644":"ff147d17"}[chunkId] + ".chunk.css";
};